import {
    required,
    minLength,
    maxLength,
    sameAs
} from 'vuelidate/lib/validators';
import abstractValidatorMixin from '../abstractValidator.mixin';

export default {
    mixins: [abstractValidatorMixin],
    data() {
        return {
            serverErrors: {
                password: [],
                passwordRepeat: []
            }
        };
    },
    validations: {
        formData: {
            password: {
                required,
                minLength: minLength(6),
                maxLength: maxLength(80)
            },
            passwordRepeat: {
                required,
                minLength: minLength(6),
                maxLength: maxLength(80),
                sameAsPassword: sameAs('password')
            }
        }
    },
    computed: {
        passwordErrors() {
            return this.checkErrors('password');
        },
        passwordRepeatErrors() {
            return this.checkErrors('passwordRepeat');
        }
    }
};
